import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FaChevronDown } from 'react-icons/fa'; // Import the icon

type Props = {};

const SinglePrayerDocLinks = (props: Props) => {
  const [isSinglePrayerOpen, setIsSinglePrayerOpen] = useState(false);
  const location = useLocation();

  return (
    <div className="relative">
      <button
        onClick={() => setIsSinglePrayerOpen(!isSinglePrayerOpen)} // Toggle submenu
        className={`w-full text-left p-3 mb-2 rounded-lg hover:bg-gray-700 transition-colors duration-200 flex items-center justify-between ${
          location.pathname.includes('singleprayer') ? 'relative' : ''
        }`}
      >
        {location.pathname.includes('singleprayer') && (
          <span className="absolute top-1 left-[14px] w-3 h-3 bg-blue-500 rounded-full"></span>
        )}
        <span className="ml-4">Single Prayer</span> {/* Added margin-left to keep the text in place */}
        <FaChevronDown
          className={`transition-transform ${
            isSinglePrayerOpen ? 'transform rotate-180' : ''
          }`}
        />
      </button>

      {/* Submenu with smoother Tailwind CSS transition */}
      <div
        className={`overflow-hidden px-2 py-1 transition-all duration-300 ease-in-out ${
          isSinglePrayerOpen ? 'max-h-[200px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="pl-4">
          <NavLink
            to="singleprayer/shortcodes" 
            className={({ isActive }) =>
              `block p-2 mb-2 rounded-lg hover:bg-gray-700 transition-colors duration-200 ${
                isActive ? 'bg-gray-700' : ''
              }`
            }
          >
            ShortCodes
          </NavLink>
          {/* <NavLink
            to="singleprayer/blocks" 
            className={({ isActive }) =>
              `block p-2 mb-2 rounded-lg hover:bg-gray-700 transition-colors duration-200 ${
                isActive ? 'bg-gray-700' : ''
              }`
            }
          >
            Blocks
          </NavLink> */}
        </div>
      </div>
    </div>
  );
};

export default SinglePrayerDocLinks;
